import React from 'react';
import SectionHead from './SectionHead';
import { SERVICES } from '../data';
import { useLang } from '../LangContext';
import { useScramble } from '../hooks/useScramble';

function ServiceCard({ s, lang, cardOf }) {
  const [title, play] = useScramble(s.title[lang]);

  return (
    <div className="svc__card tgt" onMouseEnter={play}>
      <div className="svc__num">{s.n} {cardOf}</div>
      <div className="svc__title">{title}</div>
      <div className="svc__desc">{s.desc[lang]}</div>
      <ul className="svc__list">
        {s.list[lang].map((l) => <li key={l}>{l}</li>)}
      </ul>
    </div>
  );
}

export default function Services() {
  const { lang, t } = useLang();

  return (
    <section className="s fullpage-section" id="services">
      <div className="s__inner">
        <SectionHead label={t.services.label} title={t.services.title} />
        <div className="svc">
          {SERVICES.map((s) => (
            <ServiceCard s={s} lang={lang} cardOf={t.services.cardOf} key={s.n} />
          ))}
        </div>
      </div>
    </section>
  );
}
